import axios from 'axios';
import store from '../store/index';
import { logWarn, log } from '../utils/log';
import { sleep } from '../utils/sleep';

const fasttrackVersion = (window && window.fasttrackVersion) ? window.fasttrackVersion : 'local';
const inboxClient = axios.create();

let retryCount = 0;

inboxClient.interceptors.response.use(
  (fulFilledResponse) => {
    if (fulFilledResponse.data && fulFilledResponse.data.Success) retryCount = 0;
    return fulFilledResponse;
  },
  (error) => {
    if (error.config && error.response && error.response.status === 401) {

      sleep(retryCount).then(() => {
        retryCount++;

        const payload = {
          sid: (window && window.sid) ? window.sid : '',
          enableJWT: store.getters.enableJWT,
          fusionUrl: store.getters.fusionUrl,
        };

        if (window.source && window.source !== '') payload.source = window.source;

        store.dispatch('authenticate', payload).then(() => {
          log('Successfully re-authenticated');

          const config = {...error.config};
          config.headers.authtoken = store.getters.authToken;

          return inboxClient.request(config);
        }).catch((error) => {
          logWarn('Failed to re-authenticate', error);
        });
      });
    }

    return Promise.reject(error);
  }
);

export const GetUserNotifications = (fusionUrl, authToken, unreadOnly) =>  inboxClient.get(`${fusionUrl}/Notifications/v2/user-notifications`, { params: {unreadOnly: unreadOnly, ftv: fasttrackVersion }, headers: { authtoken: authToken } });
export const DeleteUserNotification = (fusionUrl, authToken, messageId) => inboxClient.delete(`${fusionUrl}/Notifications/v2/user-notification/${messageId}`, { params: { ftv: fasttrackVersion }, headers: { authtoken: authToken } });
export const MarkNotificationAsRead = (fusionUrl, authToken, messageId) => inboxClient.post(`${fusionUrl}/Notifications/MarkNotificationAsRead`, { MessageId: messageId }, { params: { ftv: fasttrackVersion },  headers: { authtoken: authToken } });
